/**
 * ProfileSection - User profile display at top of sidebar
 *
 * Shows:
 * - User avatar icon
 * - User name (when expanded)
 * - Dropdown chevron (when expanded)
 */

import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';
import { useAuthStore } from '@/store/authStore';

interface ProfileSectionProps {
  isExpanded: boolean;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({ isExpanded }) => {
  const { user } = useAuthStore();

  const handlePress = () => {
    // TODO: Show profile dropdown menu
    console.log('Profile clicked');
  };

  return (
    <TouchableOpacity style={styles.container} onPress={handlePress} activeOpacity={0.7}>
      <Ionicons name="person-circle-outline" size={32} color={Colors.text.primary} />

      {isExpanded && (
        <View style={styles.textContainer}>
          <Text style={styles.userName} numberOfLines={1}>
            {user?.name || 'User'}
          </Text>
          <Ionicons name="chevron-down" size={16} color={Colors.text.tertiary} />
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.border.subtle,
  },
  textContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: 12,
    // @ts-ignore - Web-only property
    opacity: 1,
    // @ts-ignore - Web-only property
    animation: 'fadeIn 150ms ease-in 50ms both',
  },
  userName: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.text.primary,
    flex: 1,
  },
});
